module.exports = __webpack_public_path__ + "static/media/vitaldetails3.2b51d183.png";